interface Action {
    type: 'first-call-made'
        | 'second-call-made'
        | 'handle-completed-step-up'
        | 'handle-order-placement'
        | 'place-mutation-errored'
        | 'step-up-completed'
        | 'step-up-errored';
    response?: any;
    error?: any;
}

export function reducer(state: any, action: Action) {
    const order = action.response?.order;
    const orderNumber = order?.order_number;
    const payerAuth =  action.response?.payer_authentication;
    const stepUpAvailable = !! payerAuth?.is_step_up_available;

    let nextAction = null;

    switch (action.type) {
        case 'first-call-made':
            switch (true) {
                case !!orderNumber:
                    nextAction = 'handle-order-placement';
                    break;

                case !orderNumber
                && stepUpAvailable
                && !state.stepUpInProgress
                && !state.stepUpCompleted
                && !state.secondCallMade:
                    nextAction = 'initiate-step-up';
                    break;
            }

            return {
                ...state,
                firstCallMade: true,
                order,
                stepUpAvailable,
                payerAuthData: {
                    accessToken: payerAuth?.access_token,
                    stepUpUrl: payerAuth?.step_up_url,
                    challengeWindowSize: payerAuth?.challenge_window_size,
                },
                error: null,
                nextAction,
            }

        case 'step-up-completed':
            return {
                ...state,
                stepUpInProgress: false,
                stepUpCompleted: true,
                error: null,

                nextAction: state.secondCallMade ? null : 'handle-completed-step-up',
            };

        case 'step-up-errored':
            return {
                ...state,
                stepUpInProgress: false,
                stepUpCompleted: true,
                error: 'Sorry. This transaction encountered an authentification error. Please contact'
                    + ' support@nanoporetech.com and we will assist you.',
                nextAction: 'handle-errored-step-up',
            };

        case 'second-call-made':
            return {
                ...state,
                order,
                error: null,
                nextAction: 'handle-order-placement',
            };

        case 'place-mutation-errored':
            return {
                ...state,
                error: action.error,
                nextAction: null,
            }

        default:
            return {
                ...state,
                nextAction: null,
            };
    }
}
